import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { ROUTE_PATHS } from '@/lib/index';

export default function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle the auth callback
    const handleAuthCallback = async () => {
      try {
        // Get the session from the URL hash
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Auth callback error:', error);
          navigate(ROUTE_PATHS.FORUM_CREDITS);
          return;
        }

        if (session) {
          console.log('✅ Successfully logged in:', session.user.email);
          // Redirect to forum credits page
          navigate(ROUTE_PATHS.FORUM_CREDITS);
        } else {
          console.log('No session found, redirecting...');
          navigate(ROUTE_PATHS.FORUM_CREDITS);
        }
      } catch (error) {
        console.error('Error in auth callback:', error);
        navigate(ROUTE_PATHS.FORUM_CREDITS);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">Prijavljivanje...</p>
      </div>
    </div>
  );
}
